import styled from '@emotion/styled';

import { Flex } from '@skippay/core/components/Flex';
import { media } from '@skippay/core/styles/media';
import { size } from '@skippay/core/styles/spacing';

export const SIncomeContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-template-rows: auto 1fr auto;
	grid-gap: ${size(6)};

	@media ${media.lte('mobile')} {
		display: block;
	}
`;

export const SSimpleContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-gap: ${size(6)};

	@media ${media.lte('mobile')} {
		display: block;
	}
`;

export const SFullColumn = styled(Flex)<{ row: number }>`
	grid-column: 1 / 3;
	grid-row: ${({ row }) => row};

	@media ${media.lte('mobile')} {
		margin-top: ${size(4)};
	}
`;

export const SCol = styled.div<{ isFullsize?: boolean }>`
	flex: 1;

	@media ${media.gt('mobile')} {
		width: ${({ isFullsize }) => (isFullsize ? '100%' : `calc(50% - ${size(4)})`)};
	}
`;
